<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="loading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card no-body>
        <b-card-body>
          <b-row class="align-items-center">
            <b-col md="8">
              <b-button variant="outline-secondary" class="mr-1" @click="$router.push('/contenedores')">
                <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                Volver
              </b-button>
              <b-button variant="success" @click="openUploader">
                <feather-icon icon="UploadCloudIcon" class="mr-50" />
                Subir Excel
              </b-button>
              <b-button
                variant="danger"
                class="ml-1"
                :disabled="!totalElements || deleting"
                @click="deleteItems"
              >
                <b-spinner v-if="deleting" small class="mr-50" />
                <feather-icon v-else icon="Trash2Icon" class="mr-50" />
                Borrar items
              </b-button>
            </b-col>
            <b-col md="4" class="text-right mt-1 mt-md-0">
              <b-badge variant="light-primary">Registros: {{ totalElements }}</b-badge>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="paginatedRecords"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen items"
        >
          <template #cell(status)="data">
            <b-badge :variant="getStateBadgeVariant(data.item.status)">
              {{ getStateLabel(data.item.status) }}
            </b-badge>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="items-input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span>{{ totalElements }} Registros en total</span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <b-modal id="container-excel-modal" title="Subir Excel del contenedor" hide-footer centered>
      <b-form-file
        v-model="file"
        accept=".xls,.xlsx"
        browse-text="Elegir archivo"
        placeholder="Selecciona un archivo Excel"
        @input="validateFile"
      />
      <small class="text-muted d-block mt-1">
        Archivo permitido: .xls o .xlsx
      </small>

      <div class="d-flex flex-wrap justify-content-between align-items-center mt-2">
        <b-button variant="outline-primary" class="mb-50 mb-sm-0" @click="downloadTemplate">
          <feather-icon icon="DownloadIcon" class="mr-50" />
          Descargar formato
        </b-button>
        <div class="text-right">
          <b-button variant="outline-secondary" class="mr-50" @click="$bvModal.hide('container-excel-modal')">
            Cancelar
          </b-button>
          <b-button :disabled="!validFile || uploading" variant="primary" @click="submitUpload">
            <b-spinner v-if="uploading" small class="mr-50" />
            Subir
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import ContainerService from '@/services/ContainerService'
import * as XLSX from 'xlsx'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  data() {
    return {
      loading: false,
      uploading: false,
      deleting: false,
      records: [],
      fields: [
        { key: 'brand', label: 'MARCA', sortable: false },
        { key: 'totalQuantity', label: 'CANTIDAD TOTAL', sortable: false },
        { key: 'pcQuantity', label: 'CANTIDAD PC', sortable: false },
        { key: 'code', label: 'CODIGO', sortable: false },
        { key: 'unitMeasurement', label: 'UNIDAD MEDIDA', sortable: false },
        { key: 'status', label: 'ESTADO', sortable: false },
      ],
      totalElements: 0,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      currentPage: 1,
      sort: 'id',
      order: 'desc',
      file: null,
      validFile: false,
    }
  },
  computed: {
    paginatedRecords() {
      const start = (this.currentPage - 1) * this.showEntrie
      const end = start + this.showEntrie
      return this.records.slice(start, end)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    normalizeRows(data) {
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.rows)) return data.rows
      if (data && Array.isArray(data.data)) return data.data
      if (data && data.data && Array.isArray(data.data.rows)) return data.data.rows
      return []
    },
    normalizeTotal(data, rows) {
      if (data && data.count !== undefined) return data.count
      if (data && data.total !== undefined) return data.total
      if (data && data.totalElements !== undefined) return data.totalElements
      if (data && data.responseFilter && data.responseFilter.total_rows !== undefined) return data.responseFilter.total_rows
      if (data && data.data && data.data.responseFilter && data.data.responseFilter.total_rows !== undefined) return data.data.responseFilter.total_rows
      return rows.length
    },
    cambioPagina(page) {
      this.currentPage = page
    },
    changeSizePage() {
      this.currentPage = 1
    },
    getStateLabel(state) {
      const stateNum = Number(state)
      if (stateNum === 0) return 'No validado'
      if (stateNum === 1) return 'Validado'
      if (stateNum === 2) return 'Validado con Errores'
      return 'Desconocido'
    },
    getStateBadgeVariant(state) {
      const stateNum = Number(state)
      if (stateNum === 0) return 'light-secondary'
      if (stateNum === 1) return 'light-success'
      if (stateNum === 2) return 'light-warning'
      return 'light-secondary'
    },
    async getData() {
      this.records = []
      this.totalElements = 0
      this.loading = true
      const url = `?limit=10000&order=${this.order}&sort=${this.sort}`
      const resp = await ContainerService.getContainerItems(this.$route.params.id, url, this.$store)
      if (resp && resp.data) {
        this.records = this.normalizeRows(resp.data)
        this.totalElements = this.normalizeTotal(resp.data, this.records)
      }
      this.loading = false
    },
    openUploader() {
      this.file = null
      this.validFile = false
      this.uploading = false
      this.$bvModal.show('container-excel-modal')
    },
    validateFile(file) {
      this.validFile = !!file && /\.(xls|xlsx)$/i.test(file.name)
    },
    downloadTemplate() {
      const headers = ['MARCA', 'CANTIDAD TOTAL', 'CANTIDAD PC', 'CODIGO', 'UNIDAD MEDIDA']
      const worksheet = XLSX.utils.aoa_to_sheet([headers])
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Formato')
      XLSX.writeFile(workbook, 'formato_items_contenedor.xlsx')
    },
    async submitUpload() {
      if (!this.validFile || this.uploading) return
      this.uploading = true
      const resp = await ContainerService.uploadExcel(this.$route.params.id, this.file, this.$store)
      this.uploading = false

      if (resp) {
        this.$bvModal.hide('container-excel-modal')
        this.$swal({
          title: 'Excel subido',
          text: 'El archivo ha sido procesado correctamente.',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        this.currentPage = 1
        this.getData()
      } else {
        this.$swal({
          title: 'Error!',
          text: 'Hubo un error al subir el Excel.',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
    },
    async deleteItems() {
      this.$swal({
        title: 'Desea borrar todos los items?',
        text: 'Esta accion eliminara todos los items del contenedor.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, borrar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.deleting = true
          const resp = await ContainerService.deleteContainerItems(this.$route.params.id, this.$store)
          this.deleting = false

          if (resp) {
            this.$swal({
              icon: 'success',
              title: 'Eliminados!',
              text: 'Los items del contenedor han sido eliminados.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.currentPage = 1
            this.getData()
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: 'Ocurrio un error al borrar los items.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        }
      })
    },
  },
}
</script>
